import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { Person } from '../models/myreferrals.model'
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ReferralService {

	constructor(
		private http: HttpClient
	) { }

	public person: Person[] = [
		{ value: false, viewValue: 'Individual' },
		{ value: true, viewValue: 'Company' },
	];

	getReferral(referralFilterList : any, referralCode : any): Observable<any> {
		// debugger
		const params = {
			'from': referralFilterList.from,
			'to': referralFilterList.to,
			'search': referralFilterList.search,
			'statusIds': referralFilterList.statusIds,
			'fromDate': referralFilterList.fromDate,
			'toDate': referralFilterList.toDate,
		}
		return this.http.get(`${environment.endPoint}/myreferral/GetReferralListByCode?referralCode=` + referralCode + '&from=' + params.from + '&to=' + params.to + '&search=' + params.search + '&statusIds=' + params.statusIds + '&fromDate=' + params.fromDate + '&toDate=' + params.toDate)
			.pipe(
				map(res => res)
			);
	}


	getReferralAddLead(referralAddLead : any): Observable<any> {
		const params = {
			'refNo': referralAddLead.RefNo,
			'leadName': referralAddLead.LeadName,
			'personName': referralAddLead.PersonName,
			'personDesignation': referralAddLead.PersonDesignation,
			'address': referralAddLead.Address,
			'cityId': referralAddLead.CityId,
			'stateId': referralAddLead.StateId,
			'countryId': referralAddLead.CountryId,
			'mobileNo': referralAddLead.MobileNo,
			'contactNo': referralAddLead.ContactNo,
			'email': referralAddLead.Email,
			'localityId': referralAddLead.LocalityId,
			'pinCode': referralAddLead.PinCode,
			'longitude': referralAddLead.Longitude,
			'latitude' : referralAddLead.Latitude
		}
		// console.log(params);
		return this.http.post(`${environment.endPoint}/ReferralLead/Customer`, params);

	}


	getCountriesList() {

		return this.http.get(`/api/Location/GetAllCountries`)
			.pipe(
				map(res => res)
			);
	}



	getReasons(myReferralId : any): Observable<any> {
		return this.http.get(`${environment.endPoint}/referralRejection/Get?myReferralId=` + myReferralId)
			.pipe(
				map(res => res)
			);
	}

	addreferral(referral: any, C_id: any, U_id: any): Observable<any> {
		//  debugger;
		return this.http.post(`${environment.endPoint}/Account/UserRegistration?companyId=${C_id}&userId=${U_id}`, referral);
	}

	addReferralCustomer(customer: any): Observable<any> {
		//	debugger
		return this.http.post(`${environment.endPoint}/myreferral/AddCustomer`, customer);

	}

	getReferralDashboard(): Observable<any> {
		return this.http.get(`${environment.endPoint}/myreferral/GetMyReferralDashboard`)
			.pipe(
				map(res => res)
			);
	}

	getMockArray(): Person[] {
		return this.person;
	}
}
